import { useState, useEffect } from "react";
import { axiosClient, url } from "../utils/api";
import NavBar from "../components/public/NavBar";

export default function Servers() {
  let [login, setLogin] = useState(false);
  let [loding , setLoding] = useState(false)
  let [guilds, setGuilds] = useState([]);

  useEffect(() => {
    axiosClient
      .get("/guilds")
      .then((response) => {
          setLogin(true);
          setGuilds(response.data.guilds);
      })
      .catch(() => setLogin(false)).finally(()=>setLoding(true))
  }, []);

  if (login === false) {
    return (
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-12 text-center">
            <a href={url} className="btn btn-primary btn-lg">
              Login with Discord
            </a>
          </div>
        </div>
      </div>
    );
  } else if (loding === false) {
    return <div>Loading...</div>;
  } else {
    return (
      <>
        <NavBar />
        <div className="container mt-5">
          <div className="row justify-content-center">
            {guilds.map(({ id, name, icon }) => {
              return (
                <div className="col-lg-4 col-md-6 col-sm-12 mb-4" key={id}>
                  <div className="card h-100 shadow">
                    <img
                      src={`https://cdn.discordapp.com/icons/${id}/${icon}.png`}
                      className="card-img-top guild-icon"
                      alt={`${name} icon`}
                    />
                    <div className="card-body">
                      <h5 className="card-title">{name}</h5>
                      <button className="btn btn-primary btn-sm">
                        <a href={`/server/${id}`} className="text-light text-decoration-none">
                          Go to Server
                        </a>
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </>
    );
  }
}
